import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IGuaranteeLetter, IGuaranteeLettersState } from './types/GuaranteeLetter- interface'

const GuaranteeLettersState = (state: RootState): IGuaranteeLettersState => state.guaranteeLetters

export const GuaranteeLettersList = createSelector(
    [GuaranteeLettersState],
    (state): IGuaranteeLetter[] | [] => state.GuaranteeLetters,
)
export const LoadingGuaranteeLettersList = createSelector(
    [GuaranteeLettersState],
    (state): boolean => state.isLoadingGuaranteeLetters,
)
export const ErrorGuaranteeLettersList = createSelector(
    [GuaranteeLettersState],
    (state): string[] => state.errorGuaranteeLetters,
)

export const LastFetchTimeGuaranteeLettersList = createSelector(
    [GuaranteeLettersState],
    (state): null | number => state.lastFetchTimeGuaranteeLetters,
)
export const PolicyID = createSelector(
    [GuaranteeLettersState],
    (state): null | string => state.PolicyID,
)
export const CurrentPageTasksInCase = createSelector(
    [GuaranteeLettersState],
    (state): number => state.currentPageInCase,
)

export const FileNameGuaranteeLetter = createSelector(
    [GuaranteeLettersState],
    (state): string => state.FileName,
)
export const FileDataGuaranteeLetter = createSelector(
    [GuaranteeLettersState],
    (state): string => state.FileData,
)